class ShippingEstimate {
  constructor() {
    console.log('ShippingEstimate: Initialisation...');
    this.init();
  }

  init() {
    // Attendre que le DOM soit complètement chargé
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        console.log('ShippingEstimate: DOM chargé');
        this.calculateDates();
      });
    } else {
      console.log('ShippingEstimate: DOM déjà chargé');
      this.calculateDates();
    }

    // Recalculer si le thème charge du contenu dynamiquement
    document.addEventListener('shopify:section:load', () => {
      console.log('ShippingEstimate: Section rechargée');
      this.calculateDates();
    });
  }

  calculateBusinessDays(daysToAdd) {
    let currentDate = new Date();
    let addedDays = 0;

    console.log(`ShippingEstimate: Calcul de ${daysToAdd} jours ouvrés à partir de ${currentDate.toLocaleDateString()}`);

    while (addedDays < daysToAdd) {
      currentDate.setDate(currentDate.getDate() + 1);
      const dayOfWeek = currentDate.getDay();
      // 0 = Dimanche, 6 = Samedi
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }

    console.log(`ShippingEstimate: Date de livraison estimée: ${currentDate.toLocaleDateString()}`);
    return currentDate;
  }

  formatDate(date, locale = 'fr-FR') {
    const options = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    
    let formattedDate = date.toLocaleDateString(locale, options);
    
    // Mettre la première lettre en majuscule pour le français
    if (locale === 'fr-FR') {
      formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    }
    
    return formattedDate;
  }

  calculateDates() {
    const boxes = document.querySelectorAll('.shipping-estimate-box');
    console.log(`ShippingEstimate: ${boxes.length} bloc(s) trouvé(s)`);
    
    if (boxes.length === 0) {
      console.warn('ShippingEstimate: Aucun bloc .shipping-estimate-box trouvé dans le DOM');
      return;
    }
    
    boxes.forEach((box, index) => {
      const daysToShip = parseInt(box.dataset.daysToShip) || 3;
      const dateElement = box.querySelector('[data-delivery-date]');
      
      console.log(`ShippingEstimate: Bloc ${index + 1}:`, {
        daysToShip,
        hasDateElement: !!dateElement
      });
      
      if (dateElement) {
        const deliveryDate = this.calculateBusinessDays(daysToShip);
        const locale = document.documentElement.lang || 'fr-FR';
        const formattedDate = this.formatDate(deliveryDate, locale);
        
        dateElement.textContent = formattedDate;
        console.log(`ShippingEstimate: Date affichée: ${formattedDate}`);
      } else {
        console.error(`ShippingEstimate: Élément [data-delivery-date] non trouvé dans le bloc ${index + 1}`);
      }
    });
  }
}

// Initialiser dès que le script est chargé
console.log('ShippingEstimate: Script chargé');
const shippingEstimateInstance = new ShippingEstimate();

// Exposer globalement pour un accès facile
window.ShippingEstimate = ShippingEstimate;
window.shippingEstimateInstance = shippingEstimateInstance;